<div class="evaluation-athlete-dialog-new">
    <form [formGroup]="evaluationNewForm" *ngIf="!isLoading">
        <h1 mat-dialog-title>
            {{ 'Evaluation_New' | translate}}
        </h1>
        <div mat-dialog-content>
            <fieldset [disabled]="isSubmitting">
                <div class="line">
                    <mat-form-field color="primary">
                        <mat-select placeholder="{{ 'Evaluation' | translate }}" formControlName="evaluation">
                            <mat-option *ngFor="let evaluation of evaluations" [value]="evaluation">
                                {{ evaluation.title }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="f['evaluation'].errors && f['evaluation'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                    </mat-form-field>
                </div>

                <div class="line line-margin">
                    <mat-form-field [hintLabel]="'date_format_hint' | translate">
                        <mat-label class="required">{{ 'EvaluationDate' | translate }}</mat-label>
                        <input matInput formControlName="date" [matDatepicker]="pickerDate" autocomplete="off">
                        <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
                        <mat-datepicker #pickerDate startView="year"></mat-datepicker>
                        <mat-error *ngIf="f['date'].errors && f['date'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                    </mat-form-field>
                </div>
            </fieldset>
        </div>
        <mat-dialog-actions>

            <button mat-button mat-dialog-close tabindex="-1">
                {{ 'Cancel' | translate}}
            </button>

            <button mat-raised-button
                    [disabled]="!coachUser"
                    (click)="submitForm()" color="accent">
                {{ 'Save' | translate}}
            </button>

        </mat-dialog-actions>
    </form>
</div>
